/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    DomainActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const fetchDomainsEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, null, DomainActions.receiveDomains))
);

export const fetchDomainEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_SHOW && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, DomainActions.receiveDomain))
);

export const updateDomainEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, DomainActions.updatedDomain))
);

export const deleteDomainEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.id, null, DomainActions.deletedDomain))
);

export const createDomainEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_CREATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, DomainActions.createdDomain))
);

export const setDefaultDomainEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_SET_DEFAULT && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, DomainActions.confirmDefaultDomain))
);

export const applyDomainEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.DOMAIN_APPLY && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, DomainActions.confirmApplyDomain))
);
